import {FC, ReactNode} from 'react'
import {Button as BSButton, ButtonProps, Spinner} from 'react-bootstrap'
import styled from 'styled-components'

interface AppButtonProps extends ButtonProps {
  text: ReactNode
  variant?: ButtonProps['variant']
  isLoading?: boolean
  onClick: () => void
}

const StyledLoader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`

export const Loader = () => {
  return (
    <StyledLoader>
      <Spinner animation='border' size='sm' />
      <span>Loading</span>
    </StyledLoader>
  )
}

export const AppButton: FC<AppButtonProps> = ({text, variant, isLoading, ...props}) => {
  return (
    <BSButton variant={variant} {...props}>
      {isLoading ? <Loader /> : text}
    </BSButton>
  )
}

AppButton.defaultProps = {
  isLoading: false,
}
